import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import { featured, blogData, blogTypes } from '../static/blogs.js';
import '../css/blog.css';
import CTA from '../components/CTA';
import SingleBlog from '../components/Blog/SingleBlog';
import BlogPost from '../components/Blog/BlogPost';
import SEO from '../components/SEO';

export const defaultBlogKeywords =
  'WE3 Academy, WE3, Coding Bootcamp, Coding academy, coding school, web development bootcamp, education, education center, educational institute, best coding bootcamp, coding bootcamp in India, coding bootcamp in mumbai, best coding bootcamp in mumbai, code school, programming bootcamp, full stack web development course, full stack web development, dev bootcamp, code bootcamp,  career courses, digital courses, course, courses, career development, career development course, social media marketing, social media marketing course, social media, best courses in mumbai, social media courses in mumbai, career development courses in mumbai, part time courses, part time course, full time courses, computer programming, computer coding, training courses, training, in-person training, real world experiences, real work environment, employability, training institute, training bootcamp, training center';

function Blog({ match, history }) {
  let featuredBlog =
    featured &&
    featured.main &&
    featured.main.id &&
    featured.main.type &&
    blogData &&
    blogData[featured.main.type] &&
    blogData[featured.main.type][featured.main.id]
      ? blogData[featured.main.type][featured.main.id]
      : null;
  const subTypeFromLink =
    match.params.type && blogData && blogData[match.params.type]
      ? blogData[match.params.type]
      : null;
  const singleBlog =
    subTypeFromLink && subTypeFromLink[match.params.id]
      ? subTypeFromLink[match.params.id]
      : null;

  let showSpecific = false;

  if (subTypeFromLink) {
    if (singleBlog)
      return (
        <SingleBlog
          id={match.params.id}
          data={singleBlog}
          allBlogs={subTypeFromLink}
          type={match.params.type}
        />
      );
    else {
      showSpecific = subTypeFromLink;
      featuredBlog =
        featured &&
        featured[match.params.type] &&
        featured[match.params.type].id &&
        blogData &&
        blogData[match.params.type] &&
        blogData[match.params.type][featured[match.params.type].id]
          ? blogData[match.params.type][featured[match.params.type].id]
          : null;
    }
  }

  return (
    <>
      <div id="blog">
        <SEO
          title="WE3 Academy | Blog | Coding Bootcamp in Mumbai"
          description="At WE3 Academy, we are bridging the gap between education and employability with our in-person training courses designed to provide you with fundamental skills and real-world experiences to accelerate your career."
          keywords={defaultBlogKeywords}
          link="/blog"
        >
          <script type="application/ld+json">
            {`
            {
            "@context" : "http://schema.org",
            "@type" : "WebPage",
            "name" : "Blogs",
            "description" : "At WE3 Academy, we are bridging the gap between education and employability with our in-person training courses designed to provide you with fundamental skills and real-world experiences to accelerate your career.",
            "url" : "https://we3academy.com/blog"
          }
          `}
          </script>
        </SEO>
        <ScrollToTop />
        <section id="featured">
          <div className="img-container">
            <img src={featuredBlog.img} alt={featuredBlog.imgAlt} />
          </div>
          <div className="content-container">
            <div>
              <h1>{featuredBlog.title}</h1>
              {showSpecific && (
                <span className="tag">{blogTypes[match.params.type]}</span>
              )}
              <p>{featuredBlog.tldr}</p>
            </div>
            <button
              className="btn btn-outline btn-outline-blue"
              onClick={() =>
                history.push(
                  showSpecific
                    ? `/blog/${match.params.type}/${
                        featured[match.params.type].id
                      }`
                    : `/blog/${featured.main.type}/${featured.main.id}`
                )
              }
            >
              Read More
            </button>
          </div>
        </section>
        <section id="blog-posts">
          <div className="blog__grid">
            {showSpecific
              ? Object.keys(showSpecific).map((id, key) =>
                  id !== featured[match.params.type].id ? (
                    <BlogPost
                      key={key}
                      id={id}
                      blog={showSpecific[id]}
                      type={match.params.type}
                    />
                  ) : null
                )
              : Object.keys(blogTypes).map((type, key) =>
                  featured &&
                  featured[type] &&
                  featured[type].id &&
                  blogData &&
                  blogData[type][featured[type].id] ? (
                    <BlogPost
                      key={key}
                      id={featured[type].id}
                      blog={blogData[type][featured[type].id]}
                      heading={blogTypes[type]}
                      type={type}
                    />
                  ) : null
                )}
          </div>
          {showSpecific && (
            <button
              className="btn btn-filled btn-filled-blue"
              onClick={() => history.push('/blog')}
            >
              See All
            </button>
          )}
        </section>
        <CTA styleType="style4" />
      </div>
    </>
  );
}

export default Blog;
